import { Command } from './Commands';

export class PublishUmbracoPage extends Command {
  priority: number = 200;
  type: string = 'Page.Umbraco.Publish';

  constructor(slug: string, message: string) {
    super(message, slug);
  }
}

export class ApproveUmbracoPage extends Command {
  priority: number = 150;
  type: string = 'Page.Umbraco.Approve';

  constructor(slug: string, message: string) {
    super(message, slug);
  }
}

export class RejectUmbracoPage extends Command {
  priority: number = 150;
  type: string = 'Page.Umbraco.Reject';

  constructor(slug: string, message: string) {
    super(message, slug);
  }
}
